<template>
  <div class="withdraw_stepper">
    <img class="stepper_line" src="@/assets/basicLevel/stepper_line_active.svg" alt="" />
    <div class="stepper_item">
      <img class="stepper_icon" src="@/assets/basicLevel/step_done.svg" alt="" />
      <div class="stepper_label">{{ $t('basicLevel.identityVerification') }}</div>
    </div>
    <div class="stepper_item">
      <div class="stepper_current">
        <img class="stepper_icon" src="@/assets/basicLevel/step_current.svg" alt="" />
        <span>2</span>
      </div>
      <div class="stepper_label">{{ $t('basicLevel.withdrawalAccountStep') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawStepper'
}
</script>

<style scoped>
.withdraw_stepper {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 0.16rem 0;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 0.04rem 0.04rem 0 rgba(224, 224, 224, 0.25);
  z-index: 1;
}

.stepper_line {
  position: absolute;
  left: 50%;
  top: 0.27rem;
  width: 1.6rem;
  height: 0.015rem;
  transform: translateX(-50%);
  display: block;
  pointer-events: none;
}

.stepper_item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.09rem;
  min-width: 0;
  height: 0.5rem;
}

.stepper_icon {
  width: 0.23rem;
  height: 0.23rem;
  display: block;
}

.stepper_current {
  position: relative;
  width: 0.23rem;
  height: 0.23rem;
  flex-shrink: 0;
}

.stepper_current span {
  position: absolute;
  left: 0.075rem;
  top: 0.025rem;
  color: #fff;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-weight: 600;
  line-height: 0.18rem;
  white-space: nowrap;
}

.stepper_label {
  width: 100%;
  padding: 0 0.12rem;
  box-sizing: border-box;
  color: #1ba47a;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-weight: 500;
  line-height: 0.18rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawStepper.vue